import type { UseToastOptions } from "@chakra-ui/react";
import type { TFunction } from "i18next";
import { FrameworkRole, type ContractDto } from "../../../../autogen/bff-api";

export const publishedToast = (
  t: TFunction,
  published: ContractDto,
  actingOrganizationId: string,
): UseToastOptions => {
  const sentToSupplier =
    published.frameworkRole === FrameworkRole.CallOff &&
    published.owningOrganizationId === actingOrganizationId;
  const supplierName = sentToSupplier
    ? published.counterparty?.organization?.name
    : undefined;
  if (!supplierName) {
    return {
      title: t("Contract published!"),
      description: t("Your contract is now published!"),
      status: "success",
    };
  }
  return {
    title: t("The call-off is sent to {{name}}", { name: supplierName }),
    description: t(
      "{{name}} can now see the call-off, and has been notified.",
      { name: supplierName },
    ),
    status: "success",
  };
};
